import Model from "../Model";

class ClientsEmployeeUser extends Model{

    buildUrl ({ param }) {
        return ['employeeclientview/getclientsbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ClientsEmployeeUser;